import type { AnyAction } from 'redux';

import { defaultQueryParams } from 'src/app/shared/constants/queryParams';

// No longer set in react app (see store/index.client.js)
export default (state = defaultQueryParams, action: AnyAction) => {
  switch (action.type) {
    default: {
      return state;
    }
  }
};
